import { ProductSetDetails, ProductSetFormValues } from "../productsSets.types";

export const getInitialProductSetValues = (
  editableProductSet?: ProductSetDetails | null
): ProductSetFormValues => {
  return {
    id: editableProductSet?.id,
    coverMedia: editableProductSet?.coverMedia ?? null,
    title: editableProductSet?.title ?? "",
    description: editableProductSet?.description ?? "",
    showOnHome: editableProductSet?.showOnHome ?? false,
    showInSearch: editableProductSet?.showInSearch ?? false,
    allowCoverMediaDisplayInFullScreenMode:
      editableProductSet?.allowCoverMediaDisplayInFullScreenMode ?? true,
    productVariants:
      editableProductSet?.productVariants.map(
        (productVariant) => productVariant.productVariant
      ) ?? []
  };
};
